/* website-builder: small runtime helpers for cloned pages. */
(() => {
  // Live dates (delivery estimates): the same number of days ahead as on the source, in the page's language.
  const lang = document.documentElement.lang || 'en';
  document.querySelectorAll('.c-date[data-days]').forEach((el) => {
    const d = new Date(Date.now() + Number(el.dataset.days) * 864e5);
    const opts = el.dataset.weekday === 'true' ? { weekday: 'short', day: 'numeric', month: 'short' } : { day: 'numeric', month: 'long' };
    try {
      el.textContent = new Intl.DateTimeFormat(lang, opts).format(d);
    } catch {}
  });

  // Clicks recorded from a custom-coded source page (capture-custom.ts), replayed without its scripts:
  //   data-c-toggle="k" on the button; data-c-swap="k …" on the element it changes, whose content
  //   after the click is kept in [data-c-state="k"]; data-c-scroll="k" jumps to [data-c-anchor="k"].
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-c-toggle], [data-c-scroll]');
    if (!t || t.closest('[data-c-states]')) return;
    if (t.dataset.cScroll) {
      const to = document.querySelector(`[data-c-anchor~="${t.dataset.cScroll}"]`);
      if (to) {
        e.preventDefault();
        to.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    const k = t.dataset.cToggle;
    const box = document.querySelector(`[data-c-swap~="${k}"]`);
    const state = document.querySelector(`[data-c-state="${k}"]`);
    if (!box || !state) return;
    e.preventDefault();
    if (box.dataset.cShown === k) {
      box.innerHTML = box._cBase;
      delete box.dataset.cShown;
    } else {
      if (!box.dataset.cShown) box._cBase = box.innerHTML;
      box.innerHTML = state.innerHTML;
      box.dataset.cShown = k;
    }
  });
})();

/* Cart-drawer toggles (upsell switches, "shipping protection" checkbox): one click at a time.
   The theme decides add or remove from the toggle's state when the click lands; that state only
   changes after the cart answers and the drawer is drawn again, so quick repeated clicks all saw
   "off" and each one added the product once more. Clicks that come while the cart is still
   being changed are ignored. */
(() => {
  if (window.__cUpsellGuard) return;
  window.__cUpsellGuard = true;
  let pending = 0;
  let busyUntil = 0;
  window.__cCartBusy = () => pending > 0 || Date.now() < busyUntil;
  const originalFetch = window.fetch;
  window.fetch = function (input) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const mutates = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    if (mutates) pending++;
    const result = originalFetch.apply(this, arguments);
    if (mutates) {
      const done = () => { pending--; busyUntil = Date.now() + 500; }; // the drawer is drawn again shortly after the answer
      result.then(done, done);
    }
    return result;
  };
  // Show the result of a toggle at once: the switch flips and the subtotal moves by the product's price;
  // the drawer is drawn again with the real numbers when the cart has answered.
  const num = (t) => { const n = parseFloat(String(t).replace(/[^\d,.-]/g, '').replace(',', '.')); return isNaN(n) ? null : n; };
  const money = (n) => (Number.isInteger(n) ? n.toLocaleString('sv-SE') : n.toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + ' kr';
  function optimistic(el, before) {
    try {
      const now = el.dataset.selected === 'true'; // the theme flips its own switch on the tap
      if (now === before) return;
      const price = num((el.querySelector('.regular-price') || {}).textContent);
      const row = [...document.querySelectorAll('cart-drawer .cart-drawer__totals__row')].find((r) => /Delsumma/i.test(r.textContent));
      const total = row && row.querySelector('.cart-drawer__totals__row__money');
      const current = total && num(total.textContent);
      if (total && price !== null && current !== null) total.textContent = money(Math.max(0, current + (now ? price : -price)));
    } catch (err) {}
  }
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest && e.target.closest('cart-drawer-upsell');
    if (!toggle) return;
    if (pending > 0 || Date.now() < busyUntil) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return;
    }
    const before = toggle.dataset.selected === 'true';
    setTimeout(() => optimistic(toggle, before), 30); // once the theme's own handler has flipped its switch
    busyUntil = Date.now() + 4000; // released when the cart request finishes (or after 4 s if none was made)
    setTimeout(() => { if (pending === 0 && Date.now() >= busyUntil - 3500) busyUntil = 0; }, 600);
  }, true);
})();

/* Shipping protection is ticked by default: a cart that holds the product gets the 39 kr protection
   (the offer box adds it in the same request, this keeps the cart right after any other change).
   Unticking it or removing its line is remembered in this browser (c_ship_optout); ticking it again clears that.
   The free protection that comes with the 2+2 tier replaces the paid one, and a cart with only the
   protection left drops it. */
(() => {
  if (window.__cShipDefault) return;
  window.__cShipDefault = true;
  const KEY = 'c_ship_optout';
  const SEL = 'cart-drawer-upsell[data-handle="shipping-protection"]';
  const optedOut = () => { try { return localStorage.getItem(KEY) === '1'; } catch (err) { return false; } };
  const setOptOut = (on) => { try { on ? localStorage.setItem(KEY, '1') : localStorage.removeItem(KEY); } catch (err) {} };
  let auto = false;
  let timer = 0;
  let running = false;
  let tries = 0;
  document.addEventListener('click', (e) => {
    if (auto || !e.target.closest) return;
    const sw = e.target.closest(SEL);
    if (sw) return setOptOut(sw.dataset.selected === 'true');
    const rm = e.target.closest('cart-remove-button');
    if (rm && (rm.dataset.handle === 'shipping-protection' || rm.closest('.cart-item--product-shipping-protection'))) setOptOut(true);
  }, true);
  const schedule = (ms) => { clearTimeout(timer); timer = setTimeout(check, ms); };
  async function check() {
    if (running) return;
    if (window.__cCartBusy && window.__cCartBusy()) return schedule(500);
    running = true;
    try {
      const sw = document.querySelector(SEL);
      const btn = sw && sw.querySelector('.upsell-toggle-btn');
      if (!btn) return;
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const lines = cart.items || [];
      const has = (h) => lines.some((i) => i.handle === h);
      const real = lines.some((i) => i.handle !== 'shipping-protection' && i.handle !== 'shipping-protection-free');
      const want = real && !has('shipping-protection-free') && !optedOut();
      const have = has('shipping-protection');
      if (want === have) { tries = 0; return; }
      if ((sw.dataset.selected === 'true') !== have) return; // the drawer has not been drawn again yet
      if (tries++ >= 2) return;
      auto = true;
      btn.click(); // the theme's own switch: adds or removes the product and draws the drawer again
    } catch (err) {
    } finally {
      auto = false;
      running = false;
    }
  }
  const watch = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(() => schedule(700)).observe(drawer, { childList: true, subtree: true });
    schedule(1200);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', watch) : watch();
})();
